import React from "react";

export default function Download() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M4.83417 6.88667L7.58636 9.76991V2.14666C7.58636 1.84086 7.82663 1.60059 8.13243 1.60059C8.43823 1.60059 8.6785 1.84086 8.6785 2.14666V9.79163L11.4963 6.88642C11.7148 6.66799 12.0424 6.66799 12.2608 6.86457C12.4793 7.083 12.4793 7.41064 12.2827 7.62907L8.52573 11.5171C8.50388 11.5389 8.48204 11.5608 8.4602 11.5608L8.43836 11.5826C8.35098 11.6481 8.24177 11.67 8.13256 11.67H8.08887H8.02334C8.0015 11.67 7.95781 11.6481 7.93597 11.6481C7.93597 11.6481 7.91413 11.6481 7.91413 11.6263C7.89229 11.6045 7.87044 11.6045 7.8486 11.5826C7.82676 11.5826 7.82676 11.5608 7.82676 11.5608C7.80491 11.5389 7.78307 11.5389 7.78307 11.5171L4.04808 7.62907C3.82965 7.41064 3.85149 7.06116 4.06992 6.86457C4.26651 6.64615 4.61599 6.66799 4.83442 6.88642L4.83417 6.88667ZM2.14763 14.4006H14.1612C14.467 14.4006 14.7072 14.1603 14.7072 13.8545C14.7072 13.5487 14.467 13.3084 14.1612 13.3084H2.14763C1.84183 13.3084 1.60156 13.5487 1.60156 13.8545C1.60156 14.1603 1.84183 14.4006 2.14763 14.4006Z' />
    </svg>
  );
}
